import { useState } from 'react';
import { useWidgetContext } from 'contexts/WidgetProvider';
import { appAssets } from 'constants/assets';
import { FaFileCsv, FaFileExcel, FaHtml5 } from 'react-icons/fa';
import './exportingoptions.css';
import { useStore as useGlobalStore } from 'store/useGlobalStore';
import Tooltip from 'components/DynamicTable/DynamicTableTooltip';
import { ExportToImageValues } from '../../../constants/exportToImage';
import { BsFiletypePng } from 'react-icons/bs';
import { SiJpeg } from 'react-icons/si';

const ExportToFile = () => {
  const useHtmlExport = useGlobalStore((state) => state.configDashboard.useHtmlExport) ?? false;
  const { setState } = useWidgetContext();
  const DownloadIcon = appAssets.icons.DOWNLOAD_ICON;

  const exportHandler = (val: string) => {
    setState({ action: val });
    toggleMenu();
  };

  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const CSV_TEXT = 'CSV';
  const EXCEL_TEXT = 'Excel';
  const HTML_TEXT = 'HTML';
  const IconSize = 21;

  return (
    <div className="meatball-menu calendar">
      <div className="meatball-icon" onClick={toggleMenu}>
        <DownloadIcon />
      </div>
      {isOpen && (
        <div className="menu-options">
          <ul>
            {FaFileCsv ? (
              <Tooltip placement={'left'} hideBrowserTooltip={true} text={CSV_TEXT}>
                <li onClick={() => exportHandler('EXPORT_TO_CSV')}>
                  <FaFileCsv size={IconSize} />
                </li>
              </Tooltip>
            ) : null}
            {FaFileExcel ? (
              <Tooltip placement={'left'} hideBrowserTooltip={true} text={EXCEL_TEXT}>
                <li onClick={() => exportHandler('EXPORT_TO_XLSX')}>
                  <FaFileExcel size={IconSize} />
                </li>
              </Tooltip>
            ) : null}
            {useHtmlExport && FaHtml5 ? (
              <Tooltip placement={'left'} hideBrowserTooltip={true} text={HTML_TEXT}>
                <li onClick={() => exportHandler('EXPORT_TO_HTML')}>
                  <FaHtml5 size={IconSize} />
                </li>
              </Tooltip>
            ) : null}
            {BsFiletypePng ? (
              <Tooltip
                placement={'left'}
                hideBrowserTooltip={true}
                text={ExportToImageValues.pngText}
              >
                <li onClick={() => exportHandler('EXPORT_TO_PNG')}>
                  <BsFiletypePng size={IconSize} />
                </li>
              </Tooltip>
            ) : null}
            {SiJpeg ? (
              <Tooltip
                placement={'left'}
                hideBrowserTooltip={true}
                text={ExportToImageValues.jpegText}
              >
                <li onClick={() => exportHandler('EXPORT_TO_JPEG')}>
                  <SiJpeg size={IconSize} />
                </li>
              </Tooltip>
            ) : null}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ExportToFile;
